export function setShareButtons() {
  document.querySelectorAll<HTMLButtonElement>("[data-discord-share]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const url = btn.dataset.discordShare;
      if (!url) return;

      navigator.clipboard.writeText(url).then(() => {
        const original = btn.innerHTML;
        btn.textContent = "コピーしました！";
        btn.disabled = true;
        setTimeout(() => {
          btn.innerHTML = original;
          btn.disabled = false;
        }, 2000);
      });
    });
  });
}
